import Swiper, { Navigation, Autoplay } from 'swiper';
Swiper.use([Navigation, Autoplay]);

export function resizeSlideFunc() {
  //mvコラム
  const swiperSlides = document.getElementById('swiper--column');
  const breakPoint = 768;
  let columnSlide;
  let columnSlideBool = false; // 初期値を明示的に false に
  
  const createSwiper = () => {
      columnSlide = new Swiper('#swiper--column', {
          autoplay: {
              delay: 5000
          },
          loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 500,
          navigation: {
              nextEl: '#swiper--column-button-next',
              prevEl: '#swiper--column-button-prev'
          }
      });
  };
  
  // 初回のロード時に判定
  window.addEventListener('DOMContentLoaded', () => {
      if (window.matchMedia("(max-width: 768px)").matches) {
          createSwiper();
          columnSlideBool = true;
      }
  });
  
  // リサイズ時の判定
  window.addEventListener('resize', () => {
      if (window.matchMedia("(max-width: 768px)").matches && !columnSlideBool) {
          createSwiper();
          columnSlideBool = true;
      } else if (!window.matchMedia("(max-width: 768px)").matches && columnSlideBool) {
          columnSlide.destroy(false, true);
          columnSlideBool = false;
      }
  });  
}

export function slideFunc() {

  //TOPメンバー
  const memberSwiper = new Swiper('#swiper--member', {
    speed: 1000,
    effect: 'slide',
    loop: true,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: '#swiper--member-button-next',
      prevEl: '#swiper--member-button-prev'
    },
    // slidesPerView: 1,
    slidesPerView: 'auto',
    // spaceBetween: 64,  
    spaceBetween: 16,  
    centeredSlides: true,
    breakpoints: {
      768: {
        spaceBetween: 40,  
        // slidesPerView: 'auto'
      }
    }
  });

  //メンバー個別ページ
  const singleMemberSwiper = new Swiper('#swiper-single-member', {
    speed: 1000,
    effect: 'slide',
    loop: false,
    // autoplay: {
    //   delay: 5000,
    // },
    navigation: {
      nextEl: '#swiper-single-member-button-next',
      prevEl: '#swiper-single-member-button-prev'
    },
    slidesPerView: 'auto',
    spaceBetween: 16,  
    centeredSlides: true,
    breakpoints: {
      768: {
        spaceBetween: 40,  
        centeredSlides: false,
        // slidesPerView: 4,
      }
    }
  });

  //サービス
  $('.service-sec').each(function () {
    const $section = $(this);
    const $tabs = $section.find('.service-list li');
    const $swiperContainer = $section.find('.service-content-swiper');
    const $swiperWrapper = $swiperContainer.find('.swiper-wrapper');

    // スライドが3枚以上あるかチェック
    const slideCount = $swiperWrapper.find('.swiper-slide').length;
    const useLoop = slideCount >= 3;

    // Swiper 初期化
    const swiper = new Swiper($swiperContainer[0], {
      loop: useLoop,
      slidesPerView: 1,
      speed: 600,
      autoplay: {
        delay: 4000,
      },
      autoHeight: false,
      navigation: {
        nextEl: $section.find('.swiper-button-next')[0],
        prevEl: $section.find('.swiper-button-prev')[0],
      },
      on: {
        slideChange: function () {
          const realIndex = this.realIndex;
          $tabs.removeClass('active').eq(realIndex).addClass('active');
        },
      },
      observer: true,
      observeParents: true,
    });

    // liクリックでスライド切り替え
    $tabs.on('click', function () {
      const index = $(this).index();
      swiper.slideToLoop(index); // loop:true 対応
      $tabs.removeClass('active');
      $(this).addClass('active');
    });
  });  
}